"use client";

import blogData from "./blogData";
import dynamic from "next/dynamic";

const SectionTitle = dynamic(() => import("../Common/SectionTitle"), { ssr: false });
const SingleBlog = dynamic(() => import("./SingleBlog"), { ssr: false });

const Blog = () => {
  return (
    <section
      id="blog"
      className="bg-gray-light dark:bg-bg-color-dark py-16 md:py-20 lg:py-28"
    >
      <div className="container">
        <SectionTitle
          title="Our Latest Insights"
          paragraph="Explore tips, insights, and updates to help you grow your skills and business."
          center
        />

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3">
          {blogData.map((blog) => (
            <SingleBlog key={blog.id} blog={blog} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
